import { useEffect } from "react";

// ui components
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import { PermissionMenuName, UserRole } from "../../interfaces/UserRole";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRoleAsync, selectRole } from "../../reducers/userRole/userRole.actions";
import { getStatusLabel } from "../../store/helpers";
// @ts-ignore
import { MUIDataTableMeta } from "mui-datatables";
import Datatables from "../../layouts/Datatables";
import { Tooltip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

export const UserRoleListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.userRole.isLoading);
  const errorMessage = useSelector(
    (state: RootState) => state.userRole.errorMessage
  );
  const roles = useSelector((state: RootState) => state.userRole.listRoles);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.userRole].ACCESS);

  useEffect(() => {
    dispatch(getRoleAsync.request());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createRole = () => {
    history.push(`/user-role/create`);
  }

  const editRole = (role: UserRole) => {
    dispatch(selectRole(role));
    history.push(`/user-role/${role.ROLE_ID}`);
  }

  const renderRole = () => {
    if (errorMessage) {
      return (
        // <tr>
        //   <td colSpan={3} style={{textAlign: 'center'}}>
        //     Terdapat kesalahan dalam memuat data:<br/>
        //     <b>{errorMessage}</b>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
            Terdapat kesalahan dalam memuat data:<br/>
            <b>{errorMessage}</b>
        </div>
      )
    }

    if (isLoading) {
      return (
        // <tr>
        //   <td colSpan={3} style={{textAlign: 'center'}}>
        //     Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
            Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    if (roles.length === 0) {
      return (
        // <tr>
        //   <td colSpan={3} style={{textAlign: 'center'}}>
        //     Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs">Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
            Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs">Coba Perbaharui Halaman</button>
        </div>
      );
    }
    
    // return roles.map((role, index) => {
    //   if (role.NAME === 'Root Admin') return null;
    //   return (
    //     <tr key={role.ROLE_ID}>
    //       <td>{index + 1}</td>
    //       <td>{role.NAME}</td>
    //       <td>{getStatusLabel(parseInt(role.STATUS.toString()))}</td>
    //       <th>
    //         <button className="btn btn-primary btn-xs" onClick={() => editRole(role)}>
    //           <i className="fa fa-edit" aria-hidden="true"></i>
    //         </button>
    //       </th>
    //     </tr>
    //   );
    // })

    const items = roles.filter(item => item.NAME !== 'Root Admin').map((item, index) => ({
      NO: index + 1,
      id: item.ROLE_ID,
      STATUS_DESC: getStatusLabel(parseInt(item.STATUS.toString())),
      ...item,
    }));

    const getHeaderProps = (width: string, padding: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding
        },
      };
    };

    const getCellProps = (width: string, padding: string, align: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding,
          fontSize: '12px',
          textAlign: `${align}`
        },
      };
    };

    const actionRenderer = (value: any, tableMeta: MUIDataTableMeta) => {
      const row = items[tableMeta.rowIndex];

      return (
        <div style={{display: 'flex'}}>
          <Tooltip title="Ubah"
            slots={{
              transition: Zoom,
            }} 
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '11px'
                },
              },
            }}>
            <button className="btn btn-primary btn-xs" onClick={() => editRole(row)}>
              <i className="fa fa-edit" aria-hidden="true"></i>
            </button>
          </Tooltip>
        </div>
      );
    }

    const columns = [
      {
        name: "NO",
        label: "No",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('12%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('12%', '5px 0 5px 10px', 'left')
        },
      },
      {
        name: "NAME",
        label: "Nama Peran",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('43%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('43%', '5px 0 5px 10px', 'left')
        }
      },
      {
        name: "STATUS_DESC",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        }
      },
      { 
        name: "actions",
        label: " ",
        options: {
          filter: false,
          sort: false,
          download: false,
          setCellHeaderProps: () => getHeaderProps('9%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('9%', '5px 0 5px 10px', 'left'),
          customBodyRender: actionRenderer
        },
      }
    ];
    
    return (
      <Datatables data={items} col={columns} title={'Daftar Peran Pengguna'} />
    )
  }

  return (
    <UserRoleListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-6">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title">Daftar Peran Pengguna</h3>

                <div className="box-tools">
                  <button
                    disabled={!role.create}
                    className="btn btn-primary"
                    onClick={createRole}
                  >
                    Buat Peran Baru
                  </button>
                </div>
              </div>
              {/* <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nama Peran</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { renderRole() }
                  </tbody>
                </table>
              </div> */}
              <div style={{padding: '0 10px 10px 10px'}}>
                { renderRole() }
              </div>
            </div>
          </div>
        </div>
      </section>
    </UserRoleListPageWrapper>
  );
};

const UserRoleListPageWrapper = styled.div``;
